import without from 'lodash/without';
import isEmpty from 'lodash/isEmpty';
import { useNavigate } from 'react-router-dom';
import { Loader, NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import {
  FINISH_INFORMATION_QUESTIONNAIRES,
  QUESTIONNAIRES_SETTINGS_MAP,
} from '@thinknet-gmbh/platform-common';

import { useGetEmployeeQuestionnaireSettingById } from 'src/hooks/employee-questionnaire-settings/get-employee-questionnaire-settings-by-id.hook';
import { useUpdateEmployeeQuestionnaireSetting } from 'src/hooks/employee-questionnaire-settings/update-employee-questionnaire-settings.hook';

import { EditEmployeeQuestionnaireSettingsForm } from '../employee-questionnaire-settings-form';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';

const EditEmployeeQuestionnaireSettings = ({ id }: { id: string }) => {
  const { questionnaireSetting, loading } = useGetEmployeeQuestionnaireSettingById(id);
  const navigate = useNavigate();

  const acceptedListData = questionnaireSetting?.settings || [];

  const previewListData = without(QUESTIONNAIRES_SETTINGS_MAP, ...acceptedListData);

  const updateEmployeeQuestionnaireSetting = useUpdateEmployeeQuestionnaireSetting({
    onSuccess: () => navigate(`${ROUTES.settings}?type=${SETTINGS_PAGES.employeeQuestionnaire}`),
  });

  const onFinishHandler = (values: any, acceptedList: string[]) => {
    if (isEmpty(acceptedList)) {
      return showNotification({
        type: NOTIFICATION_TYPE.error,
        message: 'Selected some items',
      });
    }

    const isMiniJobRequired = acceptedList.includes(
      FINISH_INFORMATION_QUESTIONNAIRES.miniJobDocument
    );

    const { uploadedFile } = values;

    const isFileValid = uploadedFile && uploadedFile?.file?.status !== 'removed';

    if (isMiniJobRequired && uploadedFile && uploadedFile?.file?.status === 'removed') {
      return showNotification({
        type: NOTIFICATION_TYPE.error,
        message: 'File not selected',
      });
    }

    const dataToUpdate = {
      name: values.name,
      settings: acceptedList,
      _id: questionnaireSetting._id,
      supervisorEmailTemplateId: values?.supervisorEmailTemplateId,
      applicantEmailTemplateId: values?.applicantEmailTemplateId,
      privacyPolicyLink: values?.privacyPolicyLink,
      miniJobDocumentId: isFileValid ? uploadedFile.file : null,
    };

    if (uploadedFile?.location) {
      delete dataToUpdate.miniJobDocumentId;
    }

    return updateEmployeeQuestionnaireSetting({
      variables: {
        payload: dataToUpdate,
      },
    });
  };

  return loading ? (
    <Loader />
  ) : (
    <EditEmployeeQuestionnaireSettingsForm
      questionnaireSetting={questionnaireSetting}
      acceptedListData={acceptedListData}
      previewListData={previewListData}
      onFinishHandler={onFinishHandler}
    />
  );
};

export default EditEmployeeQuestionnaireSettings;
